// 共通js

import "../sass/common.scss";

import htmx from "htmx.org";

import { setClickHandle } from "../jsmodules/toggleClassName";
import { SmoothScroll } from "../jsmodules/smoothScroll";
import { Modal } from "../jsmodules/modal";
import { initModalBar } from "../jsmodules/modalBar";
import { initCarousels } from "../jsmodules/carousel";
import { initReveal } from "../jsmodules/reveal";
import { initLoading, done as loadingDone, waitSide } from "../jsmodules/loading";
import { initTapFeedback } from "../jsmodules/tapFeedback";

// スムーズスクロール
const ss = new SmoothScroll();
ss.watch();

// 後から差し込まれる要素の初期化
const initDeferred = () => {
	initCarousels();
	initReveal();
};

// ローディング
initLoading();

// htmx読み込み後に初期化
const HTMX_ELM_COUNT = htmx.findAll(`[hx-trigger="load"]`).length;
if (HTMX_ELM_COUNT === 0) {
	loadingDone("htmx");
	waitSide();
}

if (HTMX_ELM_COUNT > 0) {
	let LOADED_COUNT = 0;

	htmx.on("htmx:afterSettle", () => {
		LOADED_COUNT += 1;
		if (HTMX_ELM_COUNT !== LOADED_COUNT) return;

		setClickHandle(".js-menu-trigger", "body", "opened-menu");
		// headerのTOPボタン
		ss.setJumpInpage(null, "a.top-btn");
		initDeferred();

		loadingDone("htmx");
		waitSide();

		// 描画完了を待つ
		setTimeout(() => {
			ss.addClassNameAllowsJump();
		}, 100);
	});
}

document.addEventListener("DOMContentLoaded", () => {
	const modal = new Modal();
	modal.init();
	initTapFeedback();
	initModalBar();

	ss.setJumpInpage();
	initDeferred();
});
